import { IUser, UserAccess } from 'api';

export const isUserAdmin = (user?: IUser) => {
  return user?.branches?.some(({ access }) => access === UserAccess.Admin);
};
